import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import PageHero from "@/components/PageHero";
import { FadeIn } from "@/components/FadeIn";
import { PROGRAM_DETAILS, LOGO_MARK } from "@/lib/constants";

export default function ProgramsPage() {
  return (
    <main data-testid="programs-page" className="bg-[#f7f2e8]">
      <PageHero
        crumb="Wellness Programs"
        line1="Eight Pillars."
        line2="One Way to Live Well."
        subtitle="Every Carlton program is protocol-led — assessed, personalised, delivered by experts and measured over time. Explore the pillar that fits your goal."
      />

      <section className="max-w-[1480px] mx-auto px-5 md:px-10 py-20 md:py-24">
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {PROGRAM_DETAILS.map((p, i) => (
            <FadeIn key={p.slug} delay={(i % 4) * 0.08}>
              <Link
                to={`/programs/${p.slug}`}
                data-testid={`programs-overview-card-${p.slug}`}
                className="group block bg-white border border-[#c9a14a]/20 rounded-xl overflow-hidden hover:border-[#c9a14a]/60 hover:shadow-xl transition-all duration-500 h-full"
              >
                <div className="relative aspect-[4/3] overflow-hidden">
                  <img src={p.image} alt={p.title} loading="lazy" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-[1.06]" />
                  <span className="absolute top-4 left-4 w-9 h-9 rounded-full bg-[#c9a14a] flex items-center justify-center shadow">
                    <img src={LOGO_MARK} alt="" className="w-4.5 h-4.5 w-[18px] h-[18px]" style={{ filter: "brightness(0)" }} />
                  </span>
                </div>
                <div className="p-6">
                  <p className="font-serif-display text-2xl text-[#141414] leading-tight">{p.title}</p>
                  <p className="mt-1.5 text-[12px] font-semibold tracking-wide text-[#a8813a] uppercase">{p.tagline}</p>
                  <p className="mt-3 text-[13px] text-[#4a4a4a] leading-relaxed line-clamp-3">{p.desc}</p>
                  <span className="mt-5 inline-flex items-center gap-2 text-[11px] font-bold tracking-[0.18em] uppercase text-[#c9a14a] group-hover:gap-3 transition-all">
                    View Program <ArrowRight size={13} strokeWidth={2} />
                  </span>
                </div>
              </Link>
            </FadeIn>
          ))}
        </div>
      </section>
    </main>
  );
}
